// Vendors
import React from 'react';
// Styles
import {
  LayoutBodySkeletonContainer,
  LayoutHeaderSkeletonContainer,
  LayoutSkeletonComponentContainer,
} from './layout-skeleton.component.styled';
import { LayoutHeaderSkeletonComponent } from './components/header/layout-header-skeleton.component';
// Contexts
import { useAppContextConsumerHook } from 'contexts/app.context';
// Utils
import { getCurrentStateSkeleton } from './utils/layout-skeleton.utils';

const LayoutSkeletonComponent = (): React.JSX.Element => {
  const { currentState } = useAppContextConsumerHook();

  return (
    <LayoutSkeletonComponentContainer>
      <LayoutHeaderSkeletonContainer>
        <LayoutHeaderSkeletonComponent />
      </LayoutHeaderSkeletonContainer>
      <LayoutBodySkeletonContainer>
        {getCurrentStateSkeleton({ currentState })}
      </LayoutBodySkeletonContainer>
    </LayoutSkeletonComponentContainer>
  );
};

export { LayoutSkeletonComponent };
